import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';

const AlumnoDialog = ({ visible, setVisible, alumno }) => {
  return (
    <Dialog
      header="Detalle del Alumno"
      visible={visible}
      style={{ width: '60vw' }}
      onHide={() => setVisible(false)}
      modal
    >
      {alumno && (
        <div className="p-fluid">

          {/* ================= DATOS PERSONALES ================= */}
          <h3>Datos Personales</h3>
          <Divider />

          <div className="grid">
            <div className="field col-12 md:col-4">
              <label>Matrícula</label>
              <InputText value={alumno.Matricula || ''} readOnly />
            </div>

            <div className="field col-12 md:col-4">
              <label>CURP</label>
              <InputText value={alumno.CURP || ''} readOnly />
            </div>

            <div className="field col-12 md:col-4">
              <label>Fecha de Nacimiento</label>
              <InputText value={alumno.Fecha_de_nacimiento || ''} readOnly />
            </div>

            <div className="field col-12 md:col-4">
              <label>Nombres</label>
              <InputText value={alumno.Nombres || ''} readOnly />
            </div>

            <div className="field col-12 md:col-4">
              <label>Apellido Paterno</label>
              <InputText value={alumno.Apellido_paterno || ''} readOnly />
            </div>

            <div className="field col-12 md:col-4">
              <label>Apellido Materno</label>
              <InputText value={alumno.Apellido_materno || ''} readOnly />
            </div>

            <div className="field col-12 md:col-4">
              <label>Sexo</label>
              <InputText value={alumno.Sexo || ''} readOnly />
            </div>

            <div className="field col-12 md:col-4">
              <label>Nacionalidad</label>
              <InputText value={alumno.Nacionalidad || ''} readOnly />
            </div>
          </div>

          {/* ================= DATOS ESCOLARES ================= */}
          <h3 className="mt-4">Datos Escolares</h3>
          <Divider />

          <div className="grid">
            <div className="field col-12 md:col-3">
              <label>Grado</label>
              <InputText value={alumno.Grado || ''} readOnly />
            </div>

            <div className="field col-12 md:col-3">
              <label>Grupo</label>
              <InputText value={alumno.Grupo || ''} readOnly />
            </div>

            <div className="field col-12 md:col-3">
              <label>No. de Lista</label>
              <InputText value={alumno.no_de_lista || ''} readOnly />
            </div>

            <div className="field col-12 md:col-3">
              <label>Curso</label>
              <InputText value={alumno.CURSO || ''} readOnly />
            </div>

            <div className="field col-12">
              <label>Colegio de Origen</label>
              <InputText value={alumno.Colegio_de_origen || ''} readOnly />
            </div>
          </div>

          {/* ================= DIRECCIÓN ================= */}
          <h3 className="mt-4">Dirección</h3>
          <Divider />

          <div className="grid">
            <div className="field col-12">
              <label>Dirección</label>
              <InputText value={alumno.direccion || ''} readOnly />
            </div>

            <div className="field col-12 md:col-3">
              <label>Código Postal</label>
              <InputText value={alumno.codigoPostal || ''} readOnly />
            </div>

            <div className="field col-12 md:col-3">
              <label>Comuna</label>
              <InputText value={alumno.comuna || ''} readOnly />
            </div>

            <div className="field col-12 md:col-3">
              <label>Ciudad</label>
              <InputText value={alumno.ciudad || ''} readOnly />
            </div>

            <div className="field col-12 md:col-3">
              <label>Región</label>
              <InputText value={alumno.region || ''} readOnly />
            </div>
          </div>

          {/* ================= CONTACTO ================= */}
          <h3 className="mt-4">Contacto</h3>
          <Divider />

          <div className="grid">
            <div className="field col-12 md:col-4">
              <label>Teléfono</label>
              <InputText value={alumno.telefono || ''} readOnly />
            </div>

            <div className="field col-12 md:col-4">
              <label>Celular</label>
              <InputText value={alumno.celular || ''} readOnly />
            </div>

            <div className="field col-12 md:col-4">
              <label>Email</label>
              <InputText value={alumno.eMail || ''} readOnly />
            </div>
          </div>

        </div>
      )}
    </Dialog>
  );
};

export default AlumnoDialog;